import { GridPaginationModel } from '@mui/x-data-grid-pro';

export const DATA_TESTID_SHIPPING_DASH = 'shipping-dash';
export const DATA_TESTID_SHIPPING_TOP_STACK = 'shipping-dash-top-stack';
export const DATA_TESTID_SHIPPING_MID_STACK = 'shipping-dash-mid-stack';
export const DATA_TESTID_SHIPPING_END_STACK = 'shipping-dash-end-stack';

// Custom pagination model with page size of 10
export const SHIPPING_TABLE_PAGINATION_MODEL: GridPaginationModel = {
  page: 0,
  pageSize: 25,
};

// Local blank cell value specifically for the Shipping component
export const SHIPPING_BLANK_TABLE_CELL_VALUE = '';
